import { useCallback } from 'react'
import { checkWebView } from 'helpers'
import { useHistory, usePathname, useSearchParams } from 'router'
import { useQueryData } from 'hooks/query/context'


const useLoginSocial = ({ onError, onSuccess }) => {
  const { host } = useQueryData()
  const pathname = usePathname()
  const { redirect } = useSearchParams()
  const { isWebView } = checkWebView(navigator.userAgent)

  const loginSocial = useCallback((name) => {
    let social
    let width
    let height

    if (/\/Vk/.test(name)) {
      social = 'vk'
      width = 700
      height = 330
    }
    if (/\/Google/.test(name)) {
      social = 'google'
      width = 460
      height = 600
    }
    if (/\/Facebook/.test(name)) {
      social = 'fb'
      width = 560
      height = 550
    }
    if (/\/Mail/.test(name)) {
      social = 'mailru'
      width = 420
      height = 570
    }
    if (/\/Yandex/.test(name)) {
      social = 'ya'
      width = 360
      height = 500
    }
    if (/\/Odnoklassniki/.test(name)) {
      social = 'ok'
      width = 400
      height = 450
    }
    if (/\/Gosuslugi/.test(name)) {
      social = 'esia'
      width = 400
      height = 660
    }
    if (/\/Apple/.test(name)) {
      social = 'apple'
      width = 400
      height = 660
    }

    if (social) {
      const centerX = (window.innerWidth - width) / 2
      const centerY = (window.innerHeight - height) / 2

      if (!window.opener) {
        window.opener = {}
      }
      window.opener.onLoginError = (error) => onError(error)
      window.opener.onLoginSuccess = () => onSuccess()

      const features = `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${width},height=${height},top=${centerY},left=${centerX}`

      // this if block is temporary workaround for Apple auth
      if (social === 'apple') {
        // eslint-disable-next-line max-len
        const authLink = `https://id-dev.kk-ug2.rusatom.dev/auth/realms/master/protocol/openid-connect/auth?client_id=keycloak_js&redirect_uri=https://${host}${pathname}${redirect ? `?redirect=${redirect}` : ''}&state=a3072021-75fc-4f85-a2c6-d5ff40e22c11&response_mode=fragment&response_type=code&scope=openid&nonce=1cb66161-818c-4886-89eb-5dd01054f0e3`
        console.log({ authLink })
        if (isWebView) {
          window.location.href = authLink
        } else {
          window.open(authLink, '_self', features)
        }
      } else

      if (isWebView) {
        window.location.href = `/auth/rest/${social}`
      } else {
        window.open(`/auth/rest/${social}`, '_self', features)
      }
    }
  }, [ host, isWebView, onError, onSuccess, pathname, redirect ])

  return {
    loginSocial,
  }
}


export default useLoginSocial
